import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import InputText from 'modules/_shared/components/InputText';
import ColorPicker from 'modules/_shared/components/ColorPicker';

import { useAddFolderModal } from '../context/AddFolderModalContext';
import FolderPathLabel from './FolderPathLabel';

const AddFolderModalBody: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useAddFolderModal();

  return (
    <>
      <Modal.Body>
        <div className="form-group mb-1">
          <InputText
            id="name"
            label={t('Name')}
            value={data.name}
            onChange={actions.handleChangeName}
            required
            lgSize
          />
        </div>

        <FolderPathLabel />

        <ColorPicker value={data.style} onChange={actions.handleChangeStyle} />
      </Modal.Body>
    </>
  );
};

export default AddFolderModalBody;
